import {
	BreakpointConfigType,
	Breakpoints,
	ContainerDirectionalConfig,
	ContainerPadding,
	DesignTokenSize,
	DesignTokenSizeEnum,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { StyledSpinner } from '../styled-spinner/styled-spinner';
import { BonusCarousel } from './componentes/bonus-carousel';
import { BonusPopupLayer } from './componentes/bonus-popup-layer';
import { GetPersonUser } from '@esportal/portal-service';
import { Bonus, CarouselModeEnum, PersonBonus } from '@esportal/portal-service';
import { useMyBonus } from '../benefits/my-bonus/hooks/use-my-bonus';

export enum BonusSliderTracking {
	BONUS_FOR_YOU = 'bonus-for-you',
	BONUS_FOR_CAR = 'bonus-for-car',
	BONUS_ENJOYED = 'bonus-enjoyed',
}

export const getGeneralPaddingSizes = (): DesignTokenSizeEnum[] => {
	return [
		ContainerPadding.static400,
		ContainerPadding.static510,
		ContainerPadding.static565,
		ContainerPadding.static650,
		ContainerPadding.static800,
		ContainerPadding.static900,
		ContainerPadding.static1200,
	];
};

export const getGeneralPadding = (): ContainerDirectionalConfig<BreakpointConfigType<DesignTokenSize>> => {
	const paddingCtrSizes: DesignTokenSizeEnum[] = getGeneralPaddingSizes();
	const viewSizes: Breakpoints[] = [
		Breakpoints.default,
		Breakpoints.b560,
		Breakpoints.b960,
		Breakpoints.b1280,
		Breakpoints.b1600,
		Breakpoints.b1920,
		Breakpoints.b2560,
	];

	// Generate array from all viewSizes and after that, we desestructure the array
	// to generate a single JSON Object from array elements
	const generatedBreakpointsSizes: BreakpointConfigType<any> = viewSizes
		.map((viewSize, index) => {
			return { [viewSize]: paddingCtrSizes[index] };
		})
		.reduce((obj, item) => {
			return {
				...obj,
				...item,
			};
		});

	return {
		left: generatedBreakpointsSizes,
		right: generatedBreakpointsSizes,
	};
};

export const generateBreakPointSeparationFromSizes = (sizes: any, propertyCss: string): BreakpointConfigType<any> => {
	const viewSizes: Breakpoints[] = [
		Breakpoints.default,
		Breakpoints.b560,
		Breakpoints.b960,
		Breakpoints.b1280,
		Breakpoints.b1600,
		Breakpoints.b1920,
		Breakpoints.b2560,
	];

	// Generate array from all viewSizes and after that, we desestructure the array
	// to generate a single JSON Object from array elements
	return viewSizes
		.map((viewSize, index) => {
			return {
				[viewSize]: `${propertyCss}:  ${sizes[getGeneralPaddingSizes()[index]]};`,
			};
		})
		.reduce((obj, item) => {
			return {
				...obj,
				...item,
			};
		});
};

export const MyBonus = ({
	personBonus,
	bonusRef,
	userData,
}: {
	personBonus: PersonBonus | null;
	bonusRef: React.RefObject<HTMLElement>;
	userData: GetPersonUser | null;
}): React.ReactElement => {
	//To implement a tracking that shows how many Bonus a user has. It would be necessary to add a new tracking event
	// const trackingManager = useTrackingManager();

	// const [isTracked, setIsTracked] = useState(false);
	const { filteredBonus } = useMyBonus(personBonus);
	const [isBonusPopupVisible, setIsBonusPopupVisible] = React.useState<boolean>(false);
	const [bonusPopupData, setBonusPopupData] = React.useState<Bonus | undefined>(undefined);

	//To implement a tracking that shows how many Bonus a user has. It would be necessary to add a new tracking event

	// useEffect(() => {
	// 	const handleScroll = () => {
	// 		if (!elementRef.current || isTracked) {
	// 			return;
	// 		}

	// 		const rect = elementRef.current.getBoundingClientRect();

	// 		const isVisible =
	// 			rect.top >= 0 &&
	// 			rect.left >= 0 &&
	// 			rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
	// 			rect.right <= (window.innerWidth || document.documentElement.clientWidth);

	// 		if (isVisible && filteredBonus) {
	// 			trackingManager.trackClubVWGenericFeatureAppLoad({ contentId: `${filteredBonus.length} bonus` });
	// 			setIsTracked(true);
	// 		}
	// 	};

	// 	window.addEventListener('scroll', handleScroll);
	// 	handleScroll();

	// 	return () => {
	// 		window.removeEventListener('scroll', handleScroll);
	// 	};
	// }, [filteredBonus, isTracked]);

	return (
		<>
			<BonusPopupLayer
				className="bonus__popup"
				bonusPopupData={bonusPopupData}
				isBonusPopupVisible={isBonusPopupVisible}
				setIsBonusPopupVisible={setIsBonusPopupVisible}
				bonusLayerRef={bonusRef}
				userData={userData}
			/>
			{filteredBonus ? (
				<>
					<BonusCarousel
						bonusList={filteredBonus || []}
						carouselMode={CarouselModeEnum.PERSON}
						showButton={true}
						setBonusPopupData={setBonusPopupData}
						setIsBonusPopupVisible={setIsBonusPopupVisible}
					/>
				</>
			) : (
				<StyledSpinner variant="x-large" />
			)}
		</>
	);
};
